'use client';

import React from 'react';
import { HStack, Button } from '@shared/ui';
import { useSectionContext } from './useSectionContext';

const sectionButtonWrapperStyle = {
    position: {
        sm: 'fixed',
        lg: 'static',
    },
    left: {
        sm: 0,
        lg: 'unset',
    },
    bottom: {
        sm: 0,
        lg: 'unset',
    },
    zIndex: {
        sm: 999,
        lg: 0,
    },
    spacing: 'l',
    w: {
        sm: '100%',
        lg: 'auto',
    },
    bg: {
        sm: 'neutral.000',
        lg: 'neutral.clear',
    },
    boxShadow: {
        sm: 'xs',
        lg: 'none',
    },
    justifyContent: 'end',
    py: {
        sm: '14px',
        lg: 'none',
    },
    px: {
        sm: 'xs',
        md: 'l',
        lg: 'none',
    },
} as const;

export const SectionButtons: React.FC = () => {
    const {
        state: {
            useNegativeButton,
            isDataDispatching,
            positiveButtonContext,
            negativeButtonContext,
            disabledButtons,
        },
        actions: { handlePositiveButtonOnClick, handleNegativeButtonOnClick },
    } = useSectionContext();

    if (disabledButtons) {
        return null;
    }

    return (
        <HStack {...sectionButtonWrapperStyle}>
            {useNegativeButton && (
                <Button
                    size="sm"
                    variant="plain"
                    isDisabled={isDataDispatching}
                    onClick={handleNegativeButtonOnClick}
                    inline
                >
                    {negativeButtonContext}
                </Button>
            )}
            <Button
                size="sm"
                isLoading={isDataDispatching}
                onClick={handlePositiveButtonOnClick}
                inline
            >
                {positiveButtonContext}
            </Button>
        </HStack>
    );
};
